export const isNewSite = () => {
    const isDev = process.env.NODE_ENV === "development";
    const host = window.location.hostname;
    return isDev || host === "prometal-new.a-de.ru" || host === "new.prometal.ru" || host === "prometal.ru";
};
